// frontend/src/services/nextActivityService.js

import api from "./api";

class NextActivityService {
  async getForLead(leadId) {
    try {
      const response = await api.getNextActivitiesForLead(leadId);
      return response;
    } catch (error) {
      console.error("NextActivityService.getForLead error:", error);
      throw error.response?.data || { error: "Failed to load Next Activities" };
    }
  }

  async getActive(leadId) {
    try {
      const response = await api.getActiveNextActivity(leadId);
      return response;
    } catch (error) {
      console.error("NextActivityService.getActive error:", error);
      throw error.response?.data || { error: "Failed to load active Next Activity" };
    }
  }

  async create(leadId, payload) {
    try {
      const response = await api.createNextActivity(leadId, payload);
      return response;
    } catch (error) {
      console.error("NextActivityService.create error:", error);
      throw error.response?.data || { error: "Failed to create Next Activity" };
    }
  }

  async complete(id, remark = null) {
    try {
      const response = await api.completeNextActivity(id, { remark });
      return response;
    } catch (error) {
      console.error("NextActivityService.complete error:", error);
      throw error.response?.data || { error: "Failed to complete Next Activity" };
    }
  }

  async suspend(id, remark) {
    try {
      const response = await api.suspendNextActivity(id, { remark });
      return response;
    } catch (error) {
      console.error("NextActivityService.suspend error:", error);
      throw error.response?.data || { error: "Failed to suspend Next Activity" };
    }
  }

  async reopen(id) {
    try {
      const response = await api.reopenNextActivity(id);
      return response;
    } catch (error) {
      console.error("NextActivityService.reopen error:", error);
      throw error.response?.data || { error: "Failed to reopen Next Activity" };
    }
  }

  async logActivity(id, remark = null) {
    try {
      const response = await api.logNextActivityActivity(id, { remark });
      return response;
    } catch (error) {
      console.error("NextActivityService.logActivity error:", error);
      throw error.response?.data || { error: "Failed to log activity" };
    }
  }

  async getPastDue() {
    try {
      const response = await api.getPastDueNextActivities();
      return response;
    } catch (error) {
      console.error("NextActivityService.getPastDue error:", error);
      throw error.response?.data || { error: "Failed to load past-due items" };
    }
  }

  async bulkComplete(ids, remark = null) {
    try {
      const response = await api.bulkCompleteNextActivities({ ids, remark });
      return response;
    } catch (error) {
      console.error("NextActivityService.bulkComplete error:", error);
      throw error.response?.data || { error: "Failed to complete selected items" };
    }
  }

  async bulkSuspend(ids, remark) {
    try {
      const response = await api.bulkSuspendNextActivities({ ids, remark });
      return response;
    } catch (error) {
      console.error("NextActivityService.bulkSuspend error:", error);
      throw error.response?.data || { error: "Failed to suspend selected items" };
    }
  }
}

export default new NextActivityService();